import React, {  useState } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Checkbox,
  Tooltip,
} from "@material-ui/core";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import VerifiedUserOutlinedIcon from "@material-ui/icons/VerifiedUserOutlined";
import { useStyles, placeholder } from "./nftCard.module";

const NFTCard = (props) => {
  const classes = useStyles();

  const metadataHash = props.blockchainHash || props.ipfsHash;

  const [showTooltip, setShowTooltip] = useState(false);

  const truncateHash = (hash) => {
    if (!hash || hash.length <= 30) return hash;
    return `${hash.slice(0, 28)}...`;
  };

  const handleCopyHash = () => {
    if (metadataHash && navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(metadataHash);

      setShowTooltip(true);

      setTimeout(() => {
        setShowTooltip(false);
      }, 2000);
    }
  };

  return (
    <Card className={classes.cardRoot}>
      <CardActionArea
        component="div"
        disableRipple
        className={classes.cardActionArea}
      >
        <div className={classes.imageContainer}>
          <CardMedia
            component="img"
            alt="Carbon Credit"
            image={props.imageCarbonCredit || placeholder}
            title="Carbon Credit"
            className={classes.cardImage}
          />

          <div className={classes.activeBadge}>
            <span className={classes.activeDot} />
            ACTIVE ASSET
          </div>

          <Typography className={classes.imageTitle} variant="h1">
            Carbon Credit: 1 tonne
          </Typography>

          {props.certificate == null && (
            <div className={classes.checkboxWrapper}>
              <Checkbox
                onChange={(event) =>
                  props.handleCheckboxChange(event, props.id)
                }
                color="default"
                inputProps={{ "aria-label": "checkbox with default color" }}
                className={classes.checkbox}
              />
            </div>
          )}
        </div>

        <CardContent className={classes.contentSection}>
          <div className={classes.infoGrid}>
            <div className={classes.fieldGroup}>
              <Typography className={classes.fieldLabel}>
                PROJECT ORIGIN
              </Typography>
              <Typography
                className={classes.projectName}
                onClick={props.toggleDrawer(true, props.id)}
                style={{ cursor: "pointer" }}
              >
                {props.name_project}
              </Typography>
            </div>

            <div className={classes.fieldGroup}>
              <Typography className={classes.fieldLabel}>ASSET CODE</Typography>
              <Typography
                className={classes.assetCode}
                onClick={props.toggleDrawer(true, props.id)}
                style={{ cursor: "pointer" }}
              >
                {props.name}
              </Typography>
            </div>
          </div>

          {(props.showUrls || metadataHash) && metadataHash && (
            <div className={classes.fieldGroup}>
              <Typography className={classes.fieldLabel}>
                ON-CHAIN METADATA HASH
              </Typography>
              <div className={classes.metadataBox}>
                <div className={classes.hashRow}>
                  <Typography className={classes.metadataCode}>
                    {truncateHash(metadataHash)}
                  </Typography>

                  <Tooltip
                    title="¡Copiado!"
                    open={showTooltip}
                    placement="top"
                    arrow
                    disableHoverListener
                    disableFocusListener
                    disableTouchListener
                  >
                    <button
                      type="button"
                      className={classes.copyButton}
                      onClick={handleCopyHash}
                      aria-label="Copy metadata hash"
                    >
                      <FileCopyOutlinedIcon fontSize="small" />
                    </button>
                  </Tooltip>
                </div>

                <div className={classes.verifiedRow}>
                  <VerifiedUserOutlinedIcon
                    className={classes.verifiedIcon}
                    fontSize="small"
                  />
                  <Typography className={classes.verifiedText}>
                    {props.verified}
                  </Typography>
                </div>
              </div>
            </div>
          )}

          <div className={classes.actionArea}>
            <Button
              className={classes.offsetButton}
              onClick={props.handleOffsetClick}
            >
              OFFSET
            </Button>
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default NFTCard;
